<template>
    <div>
        <div class="section-heading">
            <h4>Products Review</h4>
            <p>Verify your product details</p>
        </div>

        <!-- Table for products review -->
        <div class="preview-controls">
            <select class="demo-select" v-model="selectedFilterPlatform" @change="getProductsReview">
                <option v-for="platform of selectedPlatforms" :key="platform.platform_id" :value="platform">{{ platform.platform_name }}</option>
            </select>
            <button class="primarycolor">
                Export
            </button>
        </div>
        <table id="products_review_tbl" v-if="tableData.length" class="w-100">
            <thead>
                <tr>
                    <th v-for="colHeader of tableHeaders" :key="colHeader.key">{{ colHeader.label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row, idx of tableData" :key="idx">
                    <td v-for="col of tableHeaders" :key="col.key + idx" class="px-4 py-3">
                        <template v-if="col.key === 'product_url'">
                            <a :href="row[col.key]" target="_blank">{{ row[col.key] }}</a>
                        </template>
                        <template v-else>{{ row[col.key] }}</template>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="noData">
            No data to show. Please make sure that products are uploaded platform wise on the previous page.
        </div>
        <div class="mt-4">
            <div class="d-flex">
                <button class="primarycolor mr-3" @click="setSelectedSection(nextSection)">Next</button>
                <button class="navigationButton" @click="setSelectedSection(previousSection)">Back</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    name: "ProdcutsReview",
    data() {
        return {
            selectedFilterPlatform: null,
            tableData: [],
            tableHeaders: [],
            currentSectionIndex: null,
            nextSection: null,
            previousSection: null
        }
    },
    computed: {
        ...mapState("DemoStore", ['selectedFeatures', 'selectedPlatforms', 'sections', 'selectedSection'])
    },
    mounted() {
        if (this.selectedPlatforms.length) {
            this.selectedFilterPlatform = this.selectedPlatforms[0];
            this.getProductsReview();
        } else {
            this.getFeatureWisePlatform()
        }
        this.currentSectionIndex = this.sections.indexOf(this.selectedSection)
        this.nextSection = this.sections[this.currentSectionIndex+1];
        this.previousSection = this.sections[this.currentSectionIndex-1];
    },
    methods: {
        ...mapActions("DemoStore", ['setDemoLoader', 'setTotalPlatforms', 'setSelectedPlatforms', 'setSelectedSection']),
        getFeatureWisePlatform() {
            this.setDemoLoader(true)
            const url = "/api/demo/feature_platform";
            const payload = {
                feature_ids: this.selectedFeatures.map(feature => feature.feature_id)
            };

            this.$http.post(url, payload).then(res => {
                let resData = res.body.data;
                let filteredSelectedPlatforms = [];

                if (resData.length) filteredSelectedPlatforms = resData.filter(platform => platform.isSelected && platform);

                this.setTotalPlatforms(resData);
                this.setSelectedPlatforms(filteredSelectedPlatforms);
                this.selectedFilterPlatform = filteredSelectedPlatforms[0];
                this.getProductsReview();
                this.setDemoLoader(false);
            }).catch(err => {
                this.setDemoLoader(false)
            })
        },
        getProductsReview() {
            $('#products_review_tbl').DataTable().destroy();
            this.setDemoLoader(true);

            this.tableHeaders = [];
            this.tableData = [];

            const url = `/api/demo/products?platform_id=${this.selectedFilterPlatform.platform_id}`;

            this.$http.get(url).then(res => {
                console.log('tbale', res.body)
                this.tableHeaders = res.body.headers;
                this.tableData = res.body.data;

                this.$nextTick(() => {
                    this.processTable('#products_review_tbl');
                    this.setDemoLoader(false);
                })
            }).catch(err => {
                console.log("Erron in getting products to review", err);
                this.setDemoLoader(false);
            })
        },

        processTable(id) {
            $(id).DataTable({
                initComplete: function (settings, json) {
                    $('.dataTables_scrollBody tfoot tr').css({ visibility: 'collapse' });
                    $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
                    $(id).wrap("<div style='overflow:auto; width:100%;position:relative;'></div>");
                },
                language: {
                    search: "",
                    paginate: {
                        first: "",
                        previous: "<",
                        next: ">",
                        last: "",
                    },
                    searchPlaceholder: "Search..."
                },
                lengthChange: false,
                pagingType: "full_numbers",
                searching: true,
                sorting: [[0, 'asc']],
                autoWidth: false,
                info: false

            })
            let search = require("../../../../../public/Icons_SVG/Search.svg");
            $(id + "_filter > label").append(`<div><img src='${search}' /></div>`);
        }
    }
}
</script>

<style scoped>
.preview-controls {
    display: flex;
    align-items: center;
    gap: 8px;
    position: absolute;
    right: 2.5%;
    top: 222px;
    z-index: 50;
}
.demo-select {
    font-family: "Poppins", sans-serif;
    color: var(--primary_brand);
    background-color: transparent;
    padding-inline: 16px;
    font-size: 16px;
    font-weight: 500;
    border: 1px solid #065559 !important;
    border-radius: 5px;
    margin-inline: 5px;
    height: 35px;
}

.demo-select:focus {
    border: 1px solid #065559 !important;
    box-shadow: none !important;
    outline: none !important;
}

.demo-btn {
    color: #919191;
    background-color: transparent;
    border: 1px solid #EBEBEB;
    border-radius: 10px;
    padding: 6px 12px;
    margin-right: 20px;
    margin-bottom: 12px;
}

.demo-btn.active {
    color: var(--primary_brand);
    border: 1px solid var(--primary_brand);
}

.demo-btn:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #EBEBEB !important;
}

.demo-btn.active:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: var(--primary_brand) !important;
}

.section-heading h4 {
    font-size: 18px;
    font-weight: 600;
}

.section-heading p {
    color: #5E5E5E;
    font-size: 14px;
    font-weight: 500;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins", sans-serif;
}

.navigationButton:hover {
    background: var(--accent_color-80);
}

.navigationButton:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}

button.primarycolor {
    height: 35px;
    border: none !important;
    margin: 0;
    background: var(--primary_brand);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

button.primarycolor:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}
</style>
<style lang="scss">
#products_review_tbl .page-item:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    box-shadow: none;
}

#products_review_tbl_paginate {
    position: relative;
    top: 12px;
    z-index: 100;
    float: right;
    width: 50vw;
}

#products_review_tbl_info {
    position: relative;
    top: 9px;
    left: 324px;
    z-index: 100;
    float: right;
    width: 50vw;
    font-size: 15px;
    color: var(--primary_brand-80);
}


#products_review_tbl_length label {
    border-style: solid;
    border-width: thin;
    padding: 0 5px;
    height: 35px;
    border-radius: 5px;
    width: 170px;
    border-color: var(--primary_brand-40);
    display: flex;
    justify-content: space-between;
}

#products_review_tbl_length h5 {
    width: fit-content;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-transform: none;
    padding: 10px 0 10px 10px;
    font-size: 15px;
    color: var(--primary_brand-80);
    margin: 0;
}

#products_review_tbl_length select {
    width: 30px;
    height: 100%;
    text-align-last: center;
    border-radius: 5px;
    margin-right: 10px !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    border-color: var(--primary_brand-40) !important;
    background-color: #fff !important;
    color: var(--primary_brand-80);
}

#products_review_tbl_paginate .page-link {
    border: none !important;
    background: none !important;
    color: var(--primary_brand-80) !important;
}

#products_review_tbl_paginate ul.pagination li.active {
    border: 1px solid #EBEBEB !important;
    border-radius: 7px;
    box-shadow: none !important;
}

#products_review_tbl {
    border-radius: 5px !important;
}

#products_review_tbl thead,
#products_review_tbl thead tr:first-child,
#products_review_tbl thead>tr:first-child>th:first-child {
    background-color: #e7eeef !important;
    border-radius: 5px 0 0 0 !important;
    border-left: 1px solid #D5D5D5 !important;
}

#products_review_tbl thead>tr:first-child>th:last-child {
    border-radius: 0 5px 0 0;
}

#products_review_tbl thead>tr>th {
    border-top: 1px solid #D5D5D5 !important;
    border-right: 1px solid #D5D5D5 !important;
    border-bottom: 1px solid #D5D5D5 !important;
    background-color: #e7eeef !important;
    padding: 16px 32px !important;
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    text-align: center !important;
}

#products_review_tbl tbody>tr>td {
    font-family: "Poppins", sans-serif !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    color: black !important;
}

#products_review_tbl th select {
    background-color: #fff !important;
    filter: brightness(99%);
    border: 1px solid #b1b1b1 !important;
    width: 100%;
    color: var(--primary_brand-60);
    font-size: 10px;
    border-radius: 7px;
    height: 33px;
}

#products_review_tbl_wrapper .scrolledDataTable {
    border-left: none;
    border-right: none;
}

#products_review_tbl_wrapper .scrolledDataTable::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
    border-radius: 10px;
    background: var(--base_color-10);
}

#products_review_tbl_wrapper .scrolledDataTable::-webkit-scrollbar {
    height: 10px;
}

#products_review_tbl_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background: var(--background);
}

#products_review_tbl_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
    background: var(--base_color-60);
}

#products_review_tbl_filter {
    float: left;
    margin-left: -104%;
}

#products_review_tbl_filter input {
    border-radius: 5px 0 0 5px !important;
    height: 35px;
    width: 220px;
    margin-bottom: 8px;
    outline: none;
    border-color: var(--primary_brand-60);
    border-right: none;
    padding: 10px 15px !important;
}

#products_review_tbl_filter input:focus {
    border-color: var(--primary_brand) !important;
    outline: none !important;
    box-shadow: none !important;
}

#products_review_tbl_filter input::placeholder {
    color: var(--primary_brand-40) !important;
}

#products_review_tbl_filter input:-ms-input-placeholder {
    color: var(--primary_brand-40) !important;
}

#products_review_tbl_filter input::-ms-input-placeholder {
    color: var(--primary_brand-40) !important;
}

#products_review_tbl_filter div {
    height: 35px;
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    margin-left: -3px;
    background-color: var(--primary_brand);
}

#products_review_tbl_filter img {
    height: 17px;
    filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#products_review_tbl_filter div.filter_icon {
    height: 35px;
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    cursor: pointer;
    background-color: var(--background);
}

#products_review_tbl_filter div.filter_icon img {
    height: 23px;
    filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%) hue-rotate(138deg) brightness(98%) contrast(95%);
}
</style>